import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MediaTypography from 'components/MediaTypography';
import { LanguageTranslationKeys } from 'i18n/languages/en';

import type { MenuItemWithText } from '@common/constants/CampusMenuTypes';

import { IconWrap, MenuButton, StyledBadge } from './styled';

interface PropsType extends MenuItemWithText<LanguageTranslationKeys> {
	onClick?: (href: string) => void;
}

function MenuItem({ icon, text, href, onClick, badge }: PropsType) {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleNavigate = () => {
		onClick ? onClick(href) : navigate(href);
	};

	const hasBadge = typeof badge === 'number' ? badge > 0 : badge === true;
	const badgeContent = typeof badge === 'number' ? badge : undefined;

	return (
		<MenuButton onClick={handleNavigate}>
			<StyledBadge
				invisible={!hasBadge}
				badgeContent={badgeContent}
				variant={typeof badge === 'number' ? 'standard' : 'dot'}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				overlap="circular"
			>
				<IconWrap>{icon}</IconWrap>
			</StyledBadge>
			<MediaTypography
				variant="subtitle2"
				textAlign="center"
				lineClamp={{ default: 2 }}
				sx={{ width: '100%', fontSize: '12px', letterSpacing: '0.1px' }}
			>
				{t(text)}
			</MediaTypography>
		</MenuButton>
	);
}

export default MenuItem;
